/** Précharge les chunks de pages au survol des liens — navigation instantanée. */
const routeLoaders = {
  '/': () => import('../pages/HomeElegant'),
  '/padel': () => import('../pages/Padel'),
  '/loisirs': () => import('../pages/Loisirs'),
  '/tournois': () => import('../pages/Tournois'),
  '/tournois-padel': () => import('../pages/TournoisPadel'),
  '/tournois-flippers': () => import('../pages/TournoisFlippers'),
  '/restaurant': () => import('../pages/Restaurant'),
  '/fitness': () => import('../pages/Fitness'),
  '/contact': () => import('../pages/Contact'),
  '/entreprises': () => import('../pages/Entreprises'),
  '/badminton': () => import('../pages/Badminton'),
  '/basket': () => import('../pages/Basket'),
  '/proshop': () => import('../pages/Padel').then((m) => m),
  '/seminaires': () => import('../pages/Seminaires'),
  '/team-building': () => import('../pages/TeamBuilding'),
  '/privatisation': () => import('../pages/Privatisation'),
  '/login': () => import('../pages/Login'),
  '/licences': () => import('../pages/Licences'),
};

const prefetched = new Set();

export function prefetchRoute(path) {
  const normalized = path?.split('?')[0]?.split('#')[0] || '/';
  const loader = routeLoaders[normalized];
  if (!loader || prefetched.has(normalized)) return;
  prefetched.add(normalized);
  loader().catch(() => prefetched.delete(normalized));
}

export function prefetchOnIntent(path) {
  if (typeof window === 'undefined') return;
  const run = () => prefetchRoute(path);
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 120);
  }
}

/** Props à étaler sur un <Link> pour précharger la page au survol. */
export function prefetchLinkProps(to) {
  const path = typeof to === 'string' ? to : to?.pathname || '/';
  const prefetch = () => prefetchOnIntent(path);
  return {
    onMouseEnter: prefetch,
    onFocus: prefetch,
    onTouchStart: prefetch,
  };
}
